import { useState } from 'react'

function Helper() {
    const [email, setEmail] = useState('')
    const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle')
    const [message, setMessage] = useState('')

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault()
        setStatus('loading')
        setMessage('')

        try {
            const response = await fetch('/api/waitlist', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: email,
                })
            })

            if (response.ok) {
                setStatus('success')
                setMessage('Thanks for joining the waitlist!')
                setEmail('')
            } else {
                const errorData = await response.json().catch(() => ({}))
                console.error('Airtable error:', response.status, errorData)
                setStatus('error')
                setMessage('Something went wrong. Please try again.')
            }
        } catch (error) {
            console.error('Network error:', error)
            setStatus('error')
            setMessage('Something went wrong. Please try again.')
        }
    }
    return (
        <div className="bg-white pb-8">
            <div className="max-w-4xl mx-auto px-4 py-16">
                <div className="space-y-8 text-gray-700 leading-relaxed">
                    <h1 className="text-2xl font-medium text-gray-900 mb-8">
                        The Job Helper
                    </h1>

                    <p>
                        6 months ago I released v1 to a small beta tester group. Since then, 250+ jobs were reviewed. 
                    </p>
                    <p> Join the waitlist to get access to v2.
                    </p>
                    {/* Waitlist Form */}
                    <div className="pt-2">
                        <form onSubmit={handleSubmit} className="max-w-md">
                            <div className="flex gap-3">
                                <input
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="Enter your email"
                                    required
                                    className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-900 focus:border-transparent"
                                    disabled={status === 'loading'}
                                />
                                <button
                                    type="submit"
                                    disabled={status === 'loading'}
                                    className="px-4 py-2 text-sm bg-gray-900 text-white rounded-lg hover:bg-gray-800 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                                >
                                    {status === 'loading' ? 'joining...' : 'join waitlist'}
                                </button>
                            </div>
                            {message && (
                                <p className={`mt-3 text-sm ${status === 'success' ? 'text-green-600' : 'text-red-600'}`}>
                                    {message}
                                </p>
                            )}
                        </form>
                    </div>

                    {/* Testimonials Section */}
                    <div className="space-y-6 pt-8">
                        <h2 className="text-lg font-medium text-gray-900">
                            ❤️ What people are saying
                        </h2>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div className="relative border border-gray-200 rounded-lg p-8 bg-white">
                                {/* Corner decorations */}
                                <div className="absolute top-0 left-0 w-3 h-3 border-t-2 border-l-2 border-gray-900"></div>
                                <div className="absolute top-0 right-0 w-3 h-3 border-t-2 border-r-2 border-gray-900"></div>
                                <div className="absolute bottom-0 left-0 w-3 h-3 border-b-2 border-l-2 border-gray-900"></div>
                                <div className="absolute bottom-0 right-0 w-3 h-3 border-b-2 border-r-2 border-gray-900"></div>

                                <p className="text-base text-gray-700 leading-relaxed text-center">
                                    "Oh my goodness... This is already <span className="font-semibold">more valuable than any software</span> I'm currently paying for to help tailor resumes."
                                </p>
                            </div>

                            <div className="relative border border-gray-200 rounded-lg p-8 bg-white">
                                {/* Corner decorations */}
                                <div className="absolute top-0 left-0 w-3 h-3 border-t-2 border-l-2 border-gray-900"></div>
                                <div className="absolute top-0 right-0 w-3 h-3 border-t-2 border-r-2 border-gray-900"></div>
                                <div className="absolute bottom-0 left-0 w-3 h-3 border-b-2 border-l-2 border-gray-900"></div>
                                <div className="absolute bottom-0 right-0 w-3 h-3 border-b-2 border-r-2 border-gray-900"></div>

                                <p className="text-base text-gray-700 leading-relaxed text-center">
                                    "I've compared your job helper to Gemini and ChatGPT and your job helper <span className="font-semibold">outperforms them every time.</span>"
                                </p>
                            </div>

                            <div className="relative border border-gray-200 rounded-lg p-8 bg-white">
                                {/* Corner decorations */}
                                <div className="absolute top-0 left-0 w-3 h-3 border-t-2 border-l-2 border-gray-900"></div>
                                <div className="absolute top-0 right-0 w-3 h-3 border-t-2 border-r-2 border-gray-900"></div>
                                <div className="absolute bottom-0 left-0 w-3 h-3 border-b-2 border-l-2 border-gray-900"></div>
                                <div className="absolute bottom-0 right-0 w-3 h-3 border-b-2 border-r-2 border-gray-900"></div>

                                <p className="text-base text-gray-700 leading-relaxed text-center">
                                    "This was mind-blowing for me. Reading the responses felt like I was getting <span className="font-semibold">insider feedback from a career counsellor/hiring manager.</span>"
                                </p>
                            </div>

                            <div className="relative border border-gray-200 rounded-lg p-8 bg-white">
                                {/* Corner decorations */}
                                <div className="absolute top-0 left-0 w-3 h-3 border-t-2 border-l-2 border-gray-900"></div>
                                <div className="absolute top-0 right-0 w-3 h-3 border-t-2 border-r-2 border-gray-900"></div>
                                <div className="absolute bottom-0 left-0 w-3 h-3 border-b-2 border-l-2 border-gray-900"></div>
                                <div className="absolute bottom-0 right-0 w-3 h-3 border-b-2 border-r-2 border-gray-900"></div>

                                <p className="text-base text-gray-700 leading-relaxed text-center">
                                    "I really like how it <span className="font-semibold">synthesizes and reads between the lines</span> to provide a perspective where an applicant could have a competitive advantage."
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Helper
